module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'table',
        'table',
    ],

    config: {
        buttonContext: 'projectTermJobsSummary',
        showHead: true,
        // showIDs: true,
        // showTDVerticalTop: true,
        isSortable: true,
        // preventSortOfField: {},
        rowActionsInline: true,
        supportLazyloading: false,
        // rowActionsProperties: {
        //     colWidth: '105px',
        // },
        // rowActions: {
        //     edit: true,
        //     customs: [
        //         // {
        //         //     buttonType: 'advertise',
        //         // },
        //         {
        //             buttonType: 'delete',
        //             neutral: true,
        //         }
        //     ]
        // },
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_jobs': true,
            'resourceChanged.bo_projectTermJobs': true
        }
    },

    model: {
        resourceFilters: {
            order: [{
                fieldCode: 'jobCode',
                direction: 'asc'
            }]
        }
    },

    methods: {
        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const refreshers = this.config.heartbeatRefreshOn || {}
            const key = message.heartbeatKey
            const baseFilters = (this.model.parentEntityForTable || {}).baseFilters || {}

            if(refreshers[key] && (
                (
                    key !== 'resourceChanged.bo_projectTermJobs'
                ) ||
                message.data.projectTermID == baseFilters.projectTermID
            )){
                this.delayedLastOf('refreshByHeartbeat', () => this.refreshData(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes }), 50)
            }
        },
    }
}